var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Job_Dashboard",
    "data-name": "Job Dashboard",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop-application",
    transform: "translate(-12.944 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-2",
    d: "M28.836,0H16.07a2.108,2.108,0,0,0-2.108,2.108v9.734A2.108,2.108,0,0,0,16.07,13.95h4.45v1.422H18.564a.8.8,0,0,0-.8.8V17.2a.8.8,0,0,0,.8.8h7.778a.8.8,0,0,0,.8-.8V16.173a.8.8,0,0,0-.8-.8H24.385V13.95h4.452a2.108,2.108,0,0,0,2.108-2.108V2.108A2.108,2.108,0,0,0,28.836,0ZM27.8,12.922a.657.657,0,1,1,.657-.658A.658.658,0,0,1,27.8,12.922Zm1.315-2.894a.8.8,0,0,1-.8.8H16.592a.8.8,0,0,1-.8-.8V2.49a.8.8,0,0,1,.8-.8H28.314a.8.8,0,0,1,.8.8v7.539Z",
    transform: "translate(0 0)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-2",
    d: "M285.326,62.313h-4.051a.3.3,0,0,0-.3.3v3.183a.3.3,0,0,0,.3.3h4.051a.3.3,0,0,0,.3-.3V62.612A.3.3,0,0,0,285.326,62.313Zm-.3,3.183h-3.452V62.912h3.452Z",
    transform: "translate(-257.279 -60.041)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-2",
    d: "M285.326,177.329h-4.051a.3.3,0,0,0-.3.3v3.183a.3.3,0,0,0,.3.3h4.051a.3.3,0,0,0,.3-.3v-3.183A.3.3,0,0,0,285.326,177.329Zm-.3,3.183h-3.452v-2.583h3.452Z",
    transform: "translate(-257.279 -170.864)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-2",
    d: "M97.7,86.316h2.022a.449.449,0,0,0,0-.9H97.7a.449.449,0,1,0,0,.9Z",
    transform: "translate(-80.256 -82.303)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-2",
    d: "M97.7,135.61h2.621a.449.449,0,0,0,0-.9H97.7a.449.449,0,1,0,0,.9Z",
    transform: "translate(-80.256 -129.8)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-2",
    d: "M102.123,184.008H97.7a.449.449,0,1,0,0,.9h4.418a.449.449,0,0,0,0-.9Z",
    transform: "translate(-80.256 -177.299)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-2",
    d: "M102.123,233.3H97.7a.449.449,0,1,0,0,.9h4.418a.449.449,0,0,0,0-.9Z",
    transform: "translate(-80.256 -224.794)",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobDashboard);
export default __webpack_public_path__ + "static/media/Job Dashboard.00a38e4900c7612942d548625d13bfb9.svg";
export { ForwardRef as ReactComponent };